import { render, staticRenderFns } from "./OrganizerStats.vue?vue&type=template&id=74d71010&"
import script from "./OrganizerStats.vue?vue&type=script&lang=js&"
export * from "./OrganizerStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports